import { useCallback, useState } from 'react';
import { useTRPCClientAPI, useTRPCMutation } from '../../../trpc/trpc';
import { useAuthTokenSuccess } from '../../common/hooks/useAuthTokenSuccess';

/**
 * The password sign-in of a directory reviewer account (`auth.reviewerSignIn`, spec 2026-10-10 MCP
 * apps §3.3). A good password stores the session token and opens `returnTo` (the OAuth consent),
 * as the email-code sign-in does.
 */
export function useReviewerSignIn() {
  const trpcClient = useTRPCClientAPI();
  const onAuthToken = useAuthTokenSuccess();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const mutation = useTRPCMutation({
    mutationFn: async () => trpcClient.auth.reviewerSignIn.mutate({ email: email.trim(), password }),
    onSuccess: (data) => {
      onAuthToken(data.token);
    },
  });

  const submit = useCallback(
    (event?: React.FormEvent) => {
      event?.preventDefault();
      if (email.trim() !== '' && password !== '') {
        mutation.mutate();
      }
    },
    [email, password, mutation]
  );

  return {
    email,
    setEmail,
    password,
    setPassword,
    submit,
    isLoading: mutation.isPending,
    error: mutation.error,
  };
}
